/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Select_AccessInputs */

const en_booking_select_access = /** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your access`)
};

const es_booking_select_access = /** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona tu acceso`)
};

const fr_booking_select_access = /** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez votre accès`)
};

const de_booking_select_access = /** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle deinen Zugang`)
};

const id_booking_select_access = /** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih akses Anda`)
};

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const ja_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const zh_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const ar_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const it_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const ru_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const pt_booking_select_access = en_booking_select_access;

/** @type {(inputs: Booking_Select_AccessInputs) => LocalizedString} */
const ko_booking_select_access = en_booking_select_access;

/**
* | output |
* | --- |
* | "Select your access" |
*
* @param {Booking_Select_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_select_access = /** @type {((inputs?: Booking_Select_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Select_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_select_access(inputs)
	if (locale === "es") return es_booking_select_access(inputs)
	if (locale === "fr") return fr_booking_select_access(inputs)
	if (locale === "de") return de_booking_select_access(inputs)
	if (locale === "ja") return ja_booking_select_access(inputs)
	if (locale === "zh") return zh_booking_select_access(inputs)
	if (locale === "ar") return ar_booking_select_access(inputs)
	if (locale === "id") return id_booking_select_access(inputs)
	if (locale === "it") return it_booking_select_access(inputs)
	if (locale === "ru") return ru_booking_select_access(inputs)
	if (locale === "pt") return pt_booking_select_access(inputs)
	return ko_booking_select_access(inputs)
});